import { getUTCDateFromLocaleDay } from 'utils/date-utils';
/* eslint-disable default-case */
import produce from 'immer';
import {
  searchLocationStation,
  setExerciseRest,
  setLocation,
  setLocationStationDate,
  videoConsole,
} from './actions';

const initialState = {
  loading: false,
  error: null,
  location: null,
  date: getUTCDateFromLocaleDay(),
  id: null,
  exerciseTime: null,
  restTime: null,
};

// eslint-disable-next-line no-unused-vars
const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case videoConsole.TRIGGER:
      draft.loading = true;
      break;
    case videoConsole.SUCCESS:
      draft.id = payload.id;
      draft.exerciseTime = payload.exerciseTime;
      draft.restTime = payload.restTime;
      break;
    case videoConsole.FULFILL:
      draft.loading = false;
      break;

    // REQUEST, not TRIGGER: setLocation and setLocationStationDate also start
    // a search. Clearing the id means a failed or in-flight search can never
    // leave the previous station's id behind for the save to update.
    case searchLocationStation.REQUEST:
      draft.loading = true;
      draft.error = null;
      draft.id = null;
      draft.exerciseTime = null;
      draft.restTime = null;
      break;
    case searchLocationStation.SUCCESS:
      draft.id = payload.id;
      draft.exerciseTime = payload.exerciseTime;
      draft.restTime = payload.restTime;
      break;
    case searchLocationStation.FAILURE:
      draft.error = payload;
      break;
    case searchLocationStation.FULFILL:
      draft.loading = false;
      break;

    case setLocation.toString():
      draft.location = payload;
      break;
    case setLocationStationDate.toString():
      draft.date = payload;
      draft.location = null;
      break;
    case setExerciseRest.toString():
      draft.exerciseTime = payload?.exerciseTime || null;
      draft.restTime = payload?.restTime || null;
      break;
    // no default
  }
}, initialState);

export default reducer;
